export const NAME = "report";

export interface Report {
  id: number;
  status: string;
  name: string;
  description: string;
  enabled: string;
}

export interface ReportFile {
  id: number;
  report_id: number;
  status: string;
  description: string;
  report_statuses: ReportFileStatus[];
  sent_time: string;
  scheduled_on: string;
  filename: string;
  name: string;
  status_display?: string;
  enabled: boolean;
}

export interface FileStatus {
  reportFile: ReportFile;
  editLink: string;
}

export interface ReportFileStatus {
  id: number;
  process: string;
  status: "success" | "failure" | "pending";
  error: null | string;
}



// WEBPACK FOOTER //
// ./client/modules/Report/constants.ts